import { toast } from "sonner";

/** A 409 DUPLICATE_CONTACT body from any contact write. */
export interface DuplicateContactBody { error: string; code: "DUPLICATE_CONTACT"; existingContactId?: string }

export function isDuplicateContactBody(b: unknown): b is DuplicateContactBody {
  return !!b && typeof b === "object" && (b as { code?: unknown }).code === "DUPLICATE_CONTACT";
}

/** Shows the server's message with an "Open" action to the existing person (/contacts/:id redirects to /coi/:id for a COI). */
export function toastDuplicateContact(body: DuplicateContactBody, navigate: (to: string) => void) {
  toast.error(body.error, body.existingContactId
    ? { action: { label: "Open", onClick: () => navigate(`/contacts/${body.existingContactId}`) } }
    : undefined);
}

/** Thrown by a mutationFn so onError can show the linked toast instead of a plain one. */
export class DuplicateContactError extends Error {
  constructor(public readonly body: DuplicateContactBody) {
    super(body.error);
    this.name = "DuplicateContactError";
  }
}

/**
 * Reads a failed contact write once. Throws DuplicateContactError for a duplicate body,
 * otherwise an Error carrying the server's message (or the fallback).
 */
export async function throwContactWriteError(res: Response, fallback: string): Promise<never> {
  const body = await res.json().catch(() => null);
  if (isDuplicateContactBody(body)) throw new DuplicateContactError(body);
  throw new Error((body && typeof body === "object" && (body as { error?: string }).error) || fallback);
}
